import { useFlags } from 'launchdarkly-react-client-sdk';
import useQueryParams from '../navigation-utils/useQueryParams';

export const useFeatureToggle = () => {
  const query = useQueryParams();

  const debugTools = query.has('debugTools');

  // Please remove feature toggles no longer in use when merging an experiment
  // This list should have all currently used feature toggle flags.
  const {
    reportsComingSoonTag,
    orgFactoryReset,
    sweepSupportChat,
    priorValueSlackMessages,
    assignmentGroupRoles,
    sfLoginHistory,
    postToMsTeamsAction,
    lgDemo,
    impactAnalysisAiAgent,
    automationsVersionHistory,
    deployAutomationAsFlow,
    hubspotV25,
    msTeamsActivityAuditLog,
    permissionsAgent,
    msTeamsCreateAndAddAction,
    tagsCenter,
    automationsAiForCreation,
    attributionFilters,
    processMining,
    supportAgentInAgenticCenter,
    sfFieldFieldsDialog,
    monitoringAgentMetadataTypes,
    deleteFunnel,
    addBulkDependenciesToCanvas,
    metadataElementsConnections,
    processMiningV2,
    canvasToolbar,
    canvasSections,
    setAsMcp,
    searchInDocumentationCard,
    dreamforceDemo,
    canvasStickyNotes,
    artifacts,
    shareChat,
    monitoringMenuConfigurations,
    universalSearchRedesign,
    environmentsPage,
  } = useFlags();

  return {
    debugTools,
    reportsComingSoonTag,
    orgFactoryReset,
    sweepSupportChat,
    priorValueSlackMessages,
    assignmentGroupRoles,
    sfLoginHistory,
    postToMsTeamsAction,
    lgDemo,
    impactAnalysisAiAgent,
    automationsVersionHistory,
    deployAutomationAsFlow,
    hubspotV2_5: hubspotV25,
    msTeamsActivityAuditLog,
    permissionsAgent,
    msTeamsCreateAndAddAction,
    tagsCenter,
    automationsAiForCreation,
    attributionFilters,
    processMining,
    supportAgentInAgenticCenter,
    sfFieldFieldsDialog,
    monitoringAgentMetadataTypes,
    deleteFunnel,
    addBulkDependenciesToCanvas,
    metadataElementsConnections,
    processMiningV2,
    canvasToolbar,
    canvasSections,
    setAsMcp,
    searchInDocumentationCard,
    dreamforceDemo,
    canvasStickyNotes,
    artifacts,
    shareChat,
    monitoringMenuConfigurations,
    universalSearchRedesign,
    environmentsPage,
  };
};
